import * as PIXI from "pixi.js";
import PIXISound from "pixi-sound";

export class SoundManager {
	private static hoverSound: PIXISound.Sound;
	private static clickSound: PIXISound.Sound;
	private static hitSound: PIXISound.Sound;
	private static shootSound: PIXISound.Sound;
	private static jumpSound: PIXISound.Sound;
	private static dieSound: PIXISound.Sound;
	private static fallSound: PIXISound.Sound;
	private static happySound: PIXISound.Sound;

	public static init(): void {
		PIXISound.context.paused = false;

		SoundManager.hoverSound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/hover.wav"]
		);
		SoundManager.clickSound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/select.wav"]
		);
		SoundManager.hitSound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/hit.wav"]
		);
		SoundManager.shootSound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/shoot.wav"]
		);

		SoundManager.jumpSound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/jump.wav"]
		);

		SoundManager.dieSound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/die.wav"]
		);
		SoundManager.fallSound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/fall.wav"]
		);
		SoundManager.happySound = PIXISound.Sound.from(
			PIXI.Loader.shared.resources["audio/happy.wav"]
		);
	}

	public static hover() {
		SoundManager.hoverSound.play();
	}

	public static click() {
		SoundManager.clickSound.play();
	}

	public static hit() {
		SoundManager.hitSound.play();
	}

	public static shoot() {
		SoundManager.shootSound.play();
	}

	public static jump() {
		SoundManager.jumpSound.play();
	}
	public static die() {
		SoundManager.dieSound.play();
	}
	public static fall() {
		SoundManager.fallSound.play();
	}
	public static happy() {
		SoundManager.happySound.play();
		SoundManager.happySound.loop = true;
	}
	public static fadeOutHappy() {
		SoundManager.happySound.stop();
		SoundManager.happySound.volume = 1;
	}
}
